<template>
	<div class="index-home">
		<div class="i-user-info">
			<img class="img" v-if="headPhotoUrl" :src="headPhotoUrl" />
			<p class="name">{{ userInfo.loginAccount }}</p>
			<p>{{ companyInfo.companyName }}</p>
		</div>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span style="float:left">
					<i class="el-icon-chat-line-round ico"></i>
					公告
				</span>
				<el-button type="text" @click="openSystemNoticeDialog()"><span class="more">MORE+</span></el-button>
			</div>
			<div class="home-notice-list">
				<div v-for="systemNotice in systemNotices" class="item" @click="openSystemNoticeDialog(systemNotice)">
					{{ systemNotice.title }}
					<span class="time">{{ systemNotice.modifyDate.substring(0, 10) }}</span>
				</div>
			</div>
		</el-card>
		<!-- <el-dialog
      title="公告列表"
      width="1001px"
      custom-class="dialog-style news-box"
      :visible.sync="dialogVisible"
      >
        <div class="n-list">
          <div class="item">
            <div class="name"><em>顶</em>这是新闻公共</div>
            <p>2022-020-07</p>
          </div>
          <div class="item on">
            <div class="name"><em>顶</em>这是新闻公共</div>
            <p>2022-020-07</p>
          </div>
          <div class="item">
            <div class="name"><em>顶</em>这是新闻公共</div>
            <p>2022-020-07</p>
          </div>
          <div class="item">
            <div class="name"><em>顶</em>这是新闻公共</div>
            <p>2022-020-07</p>
          </div>
          <div class="item">
            <div class="name"><em>顶</em>这是新闻公共</div>
            <p>2022-020-07</p>
          </div>
        </div>
        <div class="n-cont">
          <h2 class="t1">一场非同寻常的视频峰会，习近平提出这些重要主张</h2>
          <h3 class="t2">
            欧洲大陆重燃战火，乌克兰局势令人担忧。关键时刻，中国、法国、德国三个大国的领导人在3月8日举行视频峰会，重点是谋和平、求发展、促合作。
          </h3>
          <p class="time">2022-08-02 12:00</p>
          <div class="c">
            <p>欧洲大陆重燃战火，乌克兰局势令人担忧。关键时刻，中国、法国、德国三个大国的领导人在3月8日举行视频峰会，重点是谋和平、求发展、促合作。</p>
            <p>在这次峰会上，习近平主席针对乌克兰局势鲜明提出中方主张，表明中方态度，既谈当务之急，又谋长远之策，展现大国担当。《时政新闻眼》为你解读。</p>
          </div>
          <div class="annex">
            <a href="#"><i class="el-icon-paperclip"></i>附件名称.html</a>
            <a href="#"><i class="el-icon-paperclip"></i>附件名称.html</a>
          </div>
        </div>
    </el-dialog> -->
		<systemNoticeInfoDialog v-if="showSystemNoticeInfoDialog" :visiable.sync="showSystemNoticeInfoDialog" :param="csnRow" :appendToTop="true"></systemNoticeInfoDialog>
	</div>
</template>

<script>
import systemNoticeInfoDialog from '@/views/user/system_notice/infoDialog.vue';
export default {
	name: 'home',
	components: {
		systemNoticeInfoDialog
	},
	data() {
		return {
			userInfo: {},
			companyInfo: {},
			systemNotices: [],
			showSystemNoticeInfoDialog: false,
			csnRow: null,
			headPhotoUrl: '',
			dialogVisible: true
		};
	},
	created() {
		this.getUserInfo();
		this.initSystemNotice();
	},
	methods: {
		getUserInfo() {
			this.$http({
				url: USER_PREFIX + '/user/currentUser',
				method: 'post',
				success: res => {
					let userInfo = res.objx;
					this.headPhotoUrl = userInfo.headPhotoUrl ? userInfo.headPhotoUrl : require('@/resources/images' + '/default-header.png');

					this.userInfo = userInfo;
				}
			});
			this.$http({
				url: USER_PREFIX + '/company_info/getCurrent',
				method: `post`,
				success: res => {
					this.companyInfo = res.objx || {};
				}
			});
		},
		initSystemNotice() {
			this.$http({
				url: USER_PREFIX + '/system_notice/listPage',
				data:{publish:true},
				method: 'post',
				success: res => {
					this.systemNotices = res.objx && res.objx.records ? res.objx.records : [];
				}
			});
		},
		openSystemNoticeDialog(row) {
			this.csnRow = row || null;
			this.showSystemNoticeInfoDialog = true;
		}
	}
};
</script>
<style lang="scss">
@import '~@/styles/variables.scss';
.index-home {
	width: 920px;
	margin: 6px auto;
	.i-user-info {
		background: url(~@/resources/images/home-img.png) $baseColor no-repeat 97% -76%;
		background-size: 280px;
		padding: 22px 42px;
		border-radius: 8px;
		color: #fff;
		margin-bottom: 8px;
		font-size: 12px;
		.name {
			opacity: 1;
			font-weight: 600;
			margin: 16px 0 14px;
			font-size: 14px;
		}
		.img {
			width: 72px;
			height: 72px;
			float: left;
			border-radius: 50%;
			border: solid 4px rgba(255, 255, 255, 0.28);
			margin-right: 20px;
		}
	}

	.box-card {
		.el-card__header {
			padding: 8px 24px;
			position: relative;
			font-size: 13px;
			span {
				margin-top: 4px;
			}
			.ico {
				font-size: 16px;
				margin-right: 4px;
				margin-top: -2px;
				vertical-align: middle;
			}
			.more {
				position: absolute;
				font-size: 12px;
				right: 12px;
				top: 50%;
				margin-top: -6px;
			}
		}
		.el-card__body {
			padding: 8px 24px;
			font-size: 14px;
			min-height: calc(100% - 300px);
			.home-notice-list {
				.item {
					padding: 6px 0;
					position: relative;
					line-height: 20px;
					padding-right: 100px;
					font-size: 12px;
					cursor: pointer;
					.time {
						position: absolute;
						right: 0;
						font-size: 13px;
						color: #999;
					}
				}
			}
		}
	}
}
</style>
